import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import analytics from './analytics';
import PremiumBirthDatePicker from './PremiumBirthDatePicker';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const HybridAnalysisTab = ({ user, onCreditUsed }) => {
  const [question, setQuestion] = useState('');
  const [birthDate, setBirthDate] = useState(user.birthdate || '');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [drawnCards, setDrawnCards] = useState([]);

  const creditCost = 10;
  // Elite/Pro users have unlimited credits
  const isUnlimited = user.subscription_type === 'elite' || user.subscription_type === 'pro' || user.credits === -1;
  const hasEnoughCredits = isUnlimited || (user.credits || 0) >= creditCost;

  const handleAnalyze = async () => {
    analytics.hybridAnalysisStarted();
    setLoading(true);
    setResult(null);
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.post(`${API_URL}/api/hybrid/analysis`, {
        question: question || 'Genel yaşam analizi',
        birth_date: birthDate,
        language: 'tr'
      }, { headers: { Authorization: `Bearer ${token}` } });
      setResult(data);
      setDrawnCards(data.cards || []);
      if (onCreditUsed) onCreditUsed();
    } catch (err) {
      setResult({ error: err.response?.data?.detail || 'Bir hata oluştu' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="tab-content">
      <h2 style={{ textAlign: 'center', color: 'white', marginBottom: '8px' }}>
        Tarot + Astroloji Hibrit Analiz
      </h2>
      <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.5)', fontSize: '14px', marginBottom: '6px' }}>
        Tarot kartlarınız ve astrolojik profiliniz birlikte analiz edilir
      </p>
      <p style={{ textAlign: 'center', color: 'rgba(192,132,252,0.7)', fontSize: '12px', marginBottom: '24px' }}>
        En güçlü ve kapsamlı okuma deneyimi
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
        <PremiumBirthDatePicker
          value={birthDate}
          onChange={(date) => setBirthDate(date)}
          label="Doğum Tarihiniz"
          testId="hybrid-birth-date"
        />
        <div>
          <label style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: '13px', marginBottom: '6px' }}>Sorunuz (opsiyonel)</label>
          <textarea
            placeholder="Aklınızdaki soruyu yazın veya boş bırakın..."
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            data-testid="hybrid-question"
            rows={3}
            style={{
              width: '100%', padding: '14px', boxSizing: 'border-box',
              background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)',
              borderRadius: '10px', color: 'white', fontSize: '15px', resize: 'vertical'
            }}
          />
        </div>
      </div>

      <button
        className="btn-primary btn-large"
        onClick={handleAnalyze}
        disabled={loading || !hasEnoughCredits}
        data-testid="hybrid-analyze-button"
        style={{ width: '100%' }}
      >
        {loading ? 'Kartlar çekiliyor ve analiz ediliyor...' : `Hibrit Analizi Başlat (${creditCost} 💎)`}
      </button>

      {!hasEnoughCredits && (
        <div style={{ marginTop: '12px', padding: '12px', background: 'rgba(239,68,68,0.1)', borderRadius: '10px', textAlign: 'center', color: 'rgba(255,255,255,0.6)', fontSize: '14px' }}>
          Yetersiz kredi. Bu işlem {creditCost} kredi gerektirir.
        </div>
      )}

      {result && !result.error && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={{ marginTop: '24px' }}>
          {drawnCards.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
              {drawnCards.map((card, i) => (
                <div key={i} style={{
                  background: 'linear-gradient(135deg, rgba(139,92,246,0.2), rgba(236,72,153,0.15))',
                  border: '1px solid rgba(139,92,246,0.3)', borderRadius: '12px',
                  padding: '16px 12px', textAlign: 'center', minWidth: '100px'
                }}>
                  <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', marginBottom: '4px' }}>{card.position || `Kart ${i + 1}`}</div>
                  <div style={{ fontSize: '15px', fontWeight: '600', color: 'white' }}>{card.name}</div>
                  {card.reversed && <div style={{ fontSize: '11px', color: '#f472b6', marginTop: '2px' }}>Ters</div>}
                </div>
              ))}
            </div>
          )}
          <div style={{ background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.2)', borderRadius: '14px', padding: '24px' }}>
            <div data-testid="hybrid-result" style={{ whiteSpace: 'pre-wrap', lineHeight: 1.8, color: 'rgba(255,255,255,0.85)', fontSize: '15px' }}>
              {result.analysis}
            </div>
          </div>
        </motion.div>
      )}

      {result?.error && (
        <div style={{ marginTop: '16px', padding: '14px', background: 'rgba(239,68,68,0.1)', borderRadius: '10px', color: '#f87171', textAlign: 'center' }}>
          {result.error}
        </div>
      )}
    </motion.div>
  );
};

export default HybridAnalysisTab;
